import React from 'react';
import { useWatch } from 'react-hook-form';
import ClassificacaoQuestao from './ClassificacaoQuestao';

/**
 * EG-41: ponte entre ClassificacaoQuestao (controlado por valor/onChange) e o
 * react-hook-form das telas de template.
 *
 * Não dá para usar dois <Controller> separados, um por campo: a regra do CA02
 * é conjunta — trocar o pilar precisa zerar o tema na MESMA transição. Dois
 * controllers independentes deixariam um tema do pilar antigo vivo no estado do
 * formulário, invisível na tela porque o seletor já não lista aquela opção.
 */
const ClassificacaoQuestaoField = ({ control, setValue, prefixo, erro, children }) => {
  const idPillar = useWatch({ control, name: `${prefixo}.id_pillar` });
  const idTheme = useWatch({ control, name: `${prefixo}.id_theme` });
  const griIds = useWatch({ control, name: `${prefixo}.gri_ids` });

  const aplicar = ({ id_pillar, id_theme, gri_ids }) => {
    setValue(`${prefixo}.id_pillar`, id_pillar ?? null, {
      shouldDirty: true,
    });
    setValue(`${prefixo}.id_theme`, id_theme ?? null, { shouldDirty: true });
    // GRI-02: array e não escalar, então o default é [] — `undefined` faria o
    // campo sumir do payload, e ausente significa "não mexa nos vínculos".
    setValue(`${prefixo}.gri_ids`, gri_ids ?? [], { shouldDirty: true });
  };

  return (
    <ClassificacaoQuestao
      valor={{
        id_pillar: idPillar ?? null,
        id_theme: idTheme ?? null,
        gri_ids: griIds ?? [],
      }}
      onChange={aplicar}
      erro={erro}
    >
      {children}
    </ClassificacaoQuestao>
  );
};

export default ClassificacaoQuestaoField;
